import { type InferOutput, number, object, optional, string } from 'valibot'

import { AREAS_SORT_KEYS, createSorterSchema } from '@/features/shared/models'

export const AreasSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(AREAS_SORT_KEYS),
  name: optional(string()), // エリア名
  code: optional(string()) // エリアコード
})

export type AreasSearch = InferOutput<typeof AreasSearchSchema>
